window.addEventListener('DOMContentLoaded', () => {
  /**
   * StoryのサイドバーElementsを取得する
   * @returns {Object|null} storyElements
   */
  const getStoryElements = () => {
    const elements = {
      main: document.querySelector('.sidebar-banner--story'),
      title: document.querySelector('.js-sidebar-stroy__title'),
      postedAt: document.querySelector('.js-sidebar-stroy__posted-at'),
      thumbnail: document.querySelector('.js-sidebar-stroy__thumbnail'),
      link: document.querySelector('.js-sidebar-stroy__link')
    };
    if (Object.values(elements).some((element) => !element)) {
      return null;
    }
    return elements;
  };

  /**
   * ISO 8601形式の日時を適切な形式に変換する
   * @param {data} date ISO 8601形式時間
   * @returns {string} 適切な形式の日時
   */
  function formatDate (dateStr) {
    const date = new Date(dateStr);

    const year = date.getFullYear();
    const month = (`0${(date.getMonth() + 1)}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    const hour = (`0${date.getHours()}`).slice(-2);
    const minute = (`0${date.getMinutes()}`).slice(-2);

    return `${year}年${month}月${day}日 ${hour}時${minute}分`;
  }

  /**
   * storyのサイドバーをレンダリングする
   * @param {Object} storyElements StoryのサイドバーElements
   * @param {Object} Storyのデータ
   */
  const renderStorySidebar = (storyElements, { hash, title, thumbnailUrl, postedAt }) => {
    storyElements.thumbnail.setAttribute('src', thumbnailUrl);
    storyElements.link.setAttribute('href', encodeURI(`/story/detail/${hash}`));
    storyElements.title.textContent = title;
    storyElements.postedAt.textContent = formatDate(postedAt);
  };

  const storyElements = getStoryElements();
  if (!storyElements) {
    return;
  }

  fetch('/story/ajax/posts/pickups')
    .then((response) => response.json())
    .then((data) => {
      if (data?.data?.length === 0) {
        throw new Error('No item data');
      }
      const item = data.data[0];

      const notExistKeys = [
        'hash', 'title', 'thumbnail_url', 'posted_at'
      ].filter((key) => !(key in item));
      if (notExistKeys.length > 0) {
        throw new Error(`Required key not exits: ${notExistKeys.join(', ')}`);
      }

      renderStorySidebar(storyElements, {
        hash: item.hash,
        title: item.title,
        thumbnailUrl: item.thumbnail_url,
        postedAt: item.posted_at
      });
    }).catch(() => {
      storyElements.main.remove();
    });
});
